import React, { useCallback, useRef, useState } from "react";
import * as Styles from "../../styledVedCourse";
import { MuiButton, InputFail } from "../../../../../Components/Form";
import { POST_REQUEST } from "../../../../../HooksApi/useApi";
import { USeInsertData } from "../../../../../HookAxios/postData";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";

import AddIcon from "@mui/icons-material/Add";

import ImageViewer from "react-simple-image-viewer";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import Typography from "@mui/material/Typography";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { useSnackbar } from "notistack";

const QPindding = ({ id, comment, DeleteComment, images }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [pendingImages, setPendingImages] = useState(images || []);

  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  // const [images, setImages] = useState([]);
  const [error, setError] = useState("");

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const fileInputRef = useRef(null);

  function handleButtonClick() {
    fileInputRef.current.click();
  }

  function handleFileInputChange(event) {
    const files = event.target.files;
    files.isNew = true;

    if (images.length < 5) {
      setPendingImages((prev) => [...prev, ...files]);
    } else {
      setError("يسمح باضافة 5 صور على الاكثر");
    }
  }

  const [ShowEdit, setShowEdit] = React.useState(false);
  const [EditValue, setEditValue] = React.useState(comment);
  const token = useSelector((state) => state.Auth.userInfo.token);
  const handelChange = (e) => {
    setEditValue(e.target.value);
  };

  const urlToObject = async (img) => {
    const response = await fetch(img);
    // here image is url/location of image
    const blob = await response.blob();
    const file = new File([blob], "image.jpg", { type: blob.type });
    return file;
  };

  const handelSubmit = async () => {
    setShowEdit(false);

    const formData = new FormData();

    for (let img of pendingImages) {
      if (img.image) {
        const res = await urlToObject(img.image);
        formData.append("images[]", res);
      }
    }

    formData.append("comment_id", id);
    formData.append("comment", EditValue);
    for (let i = 0; i < pendingImages.length; i++) {
      if (!pendingImages[i].image) {
        formData.append("images[]", pendingImages[i]);
      }
    }

    edit_comment(formData);
  };

  const {
    mutate: edit_comment,
    status: StatusEdit_comment,
    data: dataEdit_comment,
    error: errorEdit_comment,
    isLoading: isLoadingEditComment,
  } = POST_REQUEST({
    request: (data) =>
      USeInsertData("edit_comment", data, { Authorization: `Bearer ${token}` }),
    handelOnSettledError,
    handelOnSettledData,
  });
  function handelOnSettledError(error) {}
  function handelOnSettledData(data) {
    enqueueSnackbar("تم تعديل السؤال بنجاح", { variant: "success" });
    // setPendingImages([]);
  }

  function handleDeleteImage(i) {
    console.log("handleDeleteImage", i);
    setPendingImages((prev) => {
      return prev.filter((image, index) => index !== i);
    });
  }

  function onDragEnd(result) {
    setPendingImages((pre) => {
      const newValue = Array.from(pre);
      const temp = pre[result.source.index - 1];
      newValue[result.source.index - 1] = pre[result.destination.index - 1];
      newValue[result.destination.index - 1] = temp;
      return newValue;
    });
  }

  return (
    <div>
      <Styles.AccordionContentVed key={id} boxshadow="none">
        <Box sx={{ width: "100%" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Styles.AccordionContentVedItems style={{ flex: 1 }}>
              {ShowEdit ? (
                <InputFail
                  defaultValue={comment}
                  width="95%"
                  borderradius="24px"
                  border="1.5px solid  #0056D2 "
                  onChange={handelChange}
                />
              ) : (
                <Styles.AccordionTextDetails
                  sx={{ fontSize: "14px", color: "#0000005b", padding: "10px" }}
                >
                  {EditValue}
                </Styles.AccordionTextDetails>
              )}
            </Styles.AccordionContentVedItems>

            <Styles.AccordionContentVedItems>
              <Styles.AccordionTextDetails>
                {ShowEdit ? (
                  <MuiButton
                    disabled={isLoadingEditComment}
                    style={{ border: "1px solid  #0056D2 ", marginLeft: "5px" }}
                    color="#0056D2"
                    background="#fff"
                    text={"حفظ"}
                    height="32px"
                    width="60px"
                    onClick={handelSubmit}
                  />
                ) : (
                  <MuiButton
                    disabled={ShowEdit || isLoadingEditComment}
                    style={{ border: "1px solid  #0056D2 ", marginLeft: "5px" }}
                    color="#0056D2"
                    background="#fff"
                    text={isLoadingEditComment ? "جار التعديل..." : "تعديل"}
                    height="32px"
                    // width="60px"
                    onClick={() => setShowEdit(true)}
                  />
                )}
                <MuiButton
                  disabled={ShowEdit || isLoadingEditComment}
                  style={{ border: "1px solid  #E30000 " }}
                  color="#E30000"
                  background="#fff"
                  text="حذف"
                  height="32px"
                  width="60px"
                  onClick={() => DeleteComment(id)}
                />
              </Styles.AccordionTextDetails>
            </Styles.AccordionContentVedItems>
          </Box>
          <Box
            sx={{
              width: "100%",
              mt: "5px",
            }}
          >
            <DragDropContext onDragEnd={onDragEnd}>
              <Typography sx={{ color: "#DA3B3B", mt: "10px" }}>
                {" "}
                {error}
              </Typography>
              <Box>
                <Droppable
                  isDropDisabled={false}
                  droppableId={"images-list-5"}
                  type="images"
                >
                  {(provided) => (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        overflow: "auto",
                        width: "100%",
                      }}
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                    >
                      {pendingImages.map((item, index) => (
                        <Draggable
                          key={index}
                          draggableId={index + item.image}
                          index={index + 1}
                        >
                          {(provide) => (
                            <div
                              ref={provide.innerRef}
                              {...provide.draggableProps}
                              {...provide.dragHandleProps}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  borderRadius: "4px",
                                  border: "1px solid #F0F0F0",
                                  background: "#FFF",
                                  padding: "10px 20px",
                                  my: "10px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "10px",
                                  }}
                                >
                                  <div>
                                    <DragIndicatorIcon />
                                  </div>
                                  <img
                                    style={{
                                      width: "70px",
                                    }}
                                    src={
                                      item.image
                                        ? item.image
                                        : URL.createObjectURL(item)
                                    }
                                    alt="question"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      openImageViewer(index);
                                    }}
                                  />
                                </div>

                                {ShowEdit && (
                                  <IconButton
                                    onClick={() => handleDeleteImage(index)}
                                  >
                                    <DeleteIcon sx={{ color: "#DA3B3B" }} />
                                  </IconButton>
                                )}
                              </Box>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>

                <Box
                  sx={{
                    position: "relative",
                    zIndex: "1000",
                  }}
                >
                  {isViewerOpen && (
                    <ImageViewer
                      src={pendingImages.map(({ image }) => image)}
                      currentIndex={currentImage}
                      disableScroll={false}
                      closeOnClickOutside={true}
                      onClose={closeImageViewer}
                    />
                  )}
                </Box>

                {ShowEdit && (
                  <Box sx={{ width: "100%" }}>
                    <Button
                      sx={{ width: "100%" }}
                      onClick={handleButtonClick}
                      disabled={pendingImages.length === 5}
                    >
                      <AddIcon /> اضافة صورة
                    </Button>
                  </Box>
                )}
                <input
                  type="file"
                  accept="image/jpeg, image/png"
                  multiple
                  onChange={handleFileInputChange}
                  ref={fileInputRef}
                  style={{ display: "none" }}
                />
              </Box>
            </DragDropContext>
          </Box>
        </Box>
      </Styles.AccordionContentVed>
    </div>
  );
};

export default QPindding;
